import { useAtom } from "jotai";
import { isSignedInAtom } from "./authAtoms";
import { useLogout } from "@/api/AppApi/services/auth";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { deleteTokens } from "@/utils/functions/cookieOperations";

export const useAccount = () => {
  const router = useRouter();
  const [, setSignedIn] = useAtom(isSignedInAtom);
  const logoutPost = useLogout({ onSuccess: () => {}, onError: () => {} });
  const logout = () => {
    logoutPost.mutate();
    setTimeout(() => {
      deleteTokens();
      setSignedIn(false);
      router.push("/");
    }, 300);
  };
  return {
    logout,
  };
};
